import React, { useState, useEffect, useRef } from 'react';

import Tag from '../components/Tag';
import Button from '../components/Button';

import Headerbar from './Headerbar'

function ParFinger(props) {
  const bannerRef = useRef(null);
  const [height, setHeight] = useState(0);

  const Row = (props) => {
    return(<div className='border-t-[1px] border-blue p-[0.5rem] w-full h-fit keplersemi flex flex-row space-x-[0.5rem]'>
      {props.children}
    </div>)
  }

  useEffect(() => {
    const bannerHeight = () => {
      if (bannerRef.current && bannerRef.current.getBoundingClientRect().height !== height) {
        let h = bannerRef.current.getBoundingClientRect().height;
        setHeight(h)
      }
    }

    bannerHeight();
    window.addEventListener('resize', bannerHeight);
    setInterval(()=>{
      bannerHeight();
    }, 500)

    return () => {
      window.removeEventListener('resize', bannerHeight);
    }
  }, []);

    return (
    <div className='relative w-full flex flex-col justify-start items-center min-h-[840px] h-full text-blue pt-[4.5rem]'
      onMouseEnter={() => props.setHover({})}>
      <div className='flex my-auto w-full h-fit lg:max-h-[1000px] p-[1.5rem] md:p-[3rem] xl:px-[6rem] relative z-0 max-w-[2000px]'>
        <div className='min-h-fit h-full w-full flex flex-col md:flex-row items-start justify-start pb-[2rem] md:pb-0'>
          <div id='Banner' ref={bannerRef} className='w-full lg:w-1/2 xl:w-1/3 3xl:min-w-[500px] h-fit mb-[2rem] md:mb-0 md:mr-[1rem] fadein'>
            <div className='lg:max-w-[800px] driftinfast relative left-0 flex flex-col justify-start items-start h-fit min-h-full'>
              <a className='keplersemi text-blue w-fit inline md:hidden mb-[2rem]' href='/projects'>
              <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>


              <div className='w-full h-full flex flex-col justify-start'>
                <div>
                  <img className='mb-[1rem] w-[100%] h-auto max-w-[450px]' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/title.png' 
                  alt='Parametric Finger'/>
                  <div className='flex w-full h-fit py-[0.5rem] justify-start flex-wrap'>
                    <Tag text={'Ongoing'}/>
                    <Tag text={'Grant Research'}/>
                    <Tag text={'CAD'}/>
                    <Tag text={'Rapid Prototyping'}/>
                    <Tag text={'Machining'}/>
                    <Tag text={'Electronics'}/>
                  </div>
                </div>

                <img className='object-contain aspect-square w-[30%]' src={require('../images/handerc.png')} alt='HAND ERC'/>
                
                <div className='w-full flex justify-start items-start my-[1rem]'>
                  <p className='min-w-[300px] text-start'>
                  This summer, I dove deeper into robotics research at <mark>Northwestern's HAND ERC</mark>, where I designed a <mark>parameterized 3-DOF robotic finger</mark> to study how friction affects force transmission in tendon-driven systems. It supports three tendon routing methods and includes a load-cell system for measuring input tendon tensions. Next, I'll mount it on existing lab testbeds to <mark>evaluate a proposed friction model</mark> across each routing method, supporting PhD researchers building <mark>frameworks to assess robotic hand performance</mark>.
                  <br/><br/>
                  Presenting my progress to professors and PhD students each week pushed me to think critically about my design choices to <mark>improve ease of manufacturing, reduce tolerancing issues, and maximize simplicity.</mark> The experience was recognized with a <mark>$4,000 grant</mark> from Northwestern's Office of Undergraduate Research to keep pursuing the work.
                  </p>
                </div>

                <div className='w-full text-blue keplersemi'>
                  <div className='flex w-full h-fit pt-0 justify-start items-start flex-col text-blue keplermed'>
                    <Row>
                      <div className='min-w-[8rem]'>DURATION</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>Jun 2026 ~ Present</p>
                      </div>
                    </Row>
                    <Row>
                      <div className='min-w-[8rem]'>SKILLS<br/>DEVELOPED</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>1) Top-down CAD design, best practices for parameterization</p>
                        <p>2) Friction modeling theory & mechanical design principles</p>
                        <p>3) Technical communication, documentation of process</p>
                        <p>4) CNC milling, SLA & FDM printing</p>
                        <p>5) Soldering SMD microchips & components</p>
                      </div>
                    </Row>
                  </div>
                </div>

                <div className='w-full flex flex-col justify-start items-start keplersemi my-[1rem]'>
                  <Button ReducedMotion = {props.ReducedMotion} link={require('../images/projects/parfinger/grantproposal.pdf')} download={true}
                  setHover={props.setHover}>
                        <img className='h-[1rem] mr-[0.5rem] aspect-square object-contain' src={require('../images/download.png')} alt='download resume'/>
                        <div className='mt-[3px]'>GRANT PROPOSAL</div>
                  </Button>
                  <Button ReducedMotion = {props.ReducedMotion} link={require('../images/projects/parfinger/presentation_slides.zip')} download={true}
                  setHover={props.setHover}>
                        <img className='h-[1rem] mr-[0.5rem] aspect-square object-contain' src={require('../images/download.png')} alt='download resume'/>
                        <div className='mt-[3px]'>PRESENTATION SLIDES</div>
                  </Button>
                </div>

                <a className='keplersemi text-blue w-fit hidden md:inline' href='/projects'>
                <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
                </a>
              </div>
            </div>
          </div>

          <div id='scroll' className='relative w-full lg:w-1/2 xl:w-2/3 3xl:w-full flex flex-row z-0 justify-start items-start pb-[2rem] md:pb-[1rem] md:pl-[1rem]' 
            style={{height: (window.innerWidth > 768) ? height : 'fit'}}>

            <div className='driftinleft hidden md:inline absolute -z-10 w-[100%] h-[100%] right-[1.5rem] top-[1rem] pl-[1.5rem] pb-[1rem]'>
              <img className='dropshadow object-cover w-full h-full' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/sand.png' 
              alt='textured background'/>
            </div>

            <div className='bg-white w-full h-fit md:h-full flex flex-col space-y-[0.5rem] justify-start items-start md:overflow-y-scroll'>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  LITERATURE REVIEW
                </div>
              </div>
              <div className='w-full grid grid-cols-1 lg:grid-cols-2 gap-2'>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/litreview_1.png' 
                alt='lit review excerpt 1'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/litreview_2.png' 
                alt='lit review excerpt 2'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/litreview_3.png' 
                alt='lit review excerpt 3'/> 
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/litreview_4.png' 
                alt='lit review excerpt 4'/> 
              </div>

              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  PARAMETERIZATION
                </div>
              </div>
              <div className='w-full grid grid-cols-1 gap-2'>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/slide_1.png' 
                alt='finger parameterization'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/slide_2.png' 
                alt='finger parameterization'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/slide_3.png' 
                alt='finger parameterization'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/slide_4.png' 
                alt='finger parameterization'/>
              </div>

              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  CAD ASSEMBLY WITH TENSION SENSING
                </div>
              </div>
              <div className='w-full grid grid-cols-2 gap-2'>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/normal.png' 
                alt='normal assembly'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/exploded.png' 
                alt='exploded assembly'/>
              </div>
              <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/tensionsensing_wide.png' 
              alt='tensionsensing full assembly'/>
              <div className='w-full flex flex-row'>
                <img className='w-[40%] h-auto object-center object-contain mr-2' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/tensionsensing_rear.png' 
                alt='tensionsensing rear'/>
                <div>
                  <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/tension_module1.png' 
                  alt='tension module'/>
                  <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/tension_module2.png' 
                  alt='tension module'/>
                  <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/tension_module3.png' 
                  alt='tension module'/>
                </div>
              </div>


              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  MEASURING FRICTION, CALIBRATING TENSION SENSORS
                </div>
              </div>
              <div className='w-full grid grid-cols-2 gap-2'>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/testbed_1.png' 
                alt='prototype photos'/>
                <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/testbed_2.png' 
                alt='prototype photos'/>
              </div>

              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  PROTOTYPING & FABRICATION
                </div>
              </div>
              <div className='w-full flex flex-col'>
                <div className='w-full grid gap-2 grid-cols-2'>
                  <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/tensionsensor_assembly.png' 
                  alt='tension sensor assembly'/>
                  <img className='w-full h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/assembly_wiring.png' 
                  alt='assembly wiring'/>
                </div>
                <div className='w-full flex flex-row h-fit overflow-hidden'>
                  <img className='w-[70%] object-center object-contain mr-2' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/fingerassembly_1.png' 
                  alt='finger assembly 1'/>
                  <img className='w-[30%] object-center object-contain rotate-0' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/parfinger/fingerassembly_2.png' 
                  alt='finger assembly 2'/>
                </div>
              </div>

              <a className='keplersemi text-blue w-fit lg:hidden my-[2rem]' href='/projects'>
                <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Headerbar {... props}/>
    </div> );
}

export default ParFinger;